import {Locale} from "@/enums/Locale";
import {Currency} from "@/enums/Currency";

export default {
  [Locale.DE]: Currency.EURO,
  [Locale.CH]: Currency.CHF,
  [Locale.AT]: Currency.EURO,
  [Locale.EN]: Currency.DOLLAR,
}
